import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { interval, map } from 'rxjs';

import { SvgIconComponent } from '@dmb/core';

import { UserService } from '../../user';
import { ListEntry } from '../list/notification-center-list.component';

@Component({
  selector: 'dmb-notification-center-item',
  templateUrl: './notification-center-item.component.html',
  styleUrls: ['./notification-center-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, MatButtonModule, RouterLink, SvgIconComponent],
})
export class NotificationCenterItemComponent {
  private timeFormatter = toSignal(inject(UserService).language.pipe(map((lang) => new Intl.RelativeTimeFormat(lang))));
  private currentTime = toSignal(interval(60_000).pipe(map(() => Date.now())), { initialValue: Date.now() });

  item = input.required<ListEntry>();

  relaiveCreationTime = computed(() => {
    const formatter = this.timeFormatter();
    if (!formatter) {
      return '';
    }
    const passedTime = this.item().created - this.currentTime();

    const dayCount = Math.ceil(passedTime / 86_400_000);
    if (dayCount < 0) {
      return formatter.format(dayCount, 'day');
    }

    const hourCount = Math.ceil(passedTime / 3_600_000);
    if (hourCount < 0) {
      return formatter.format(hourCount, 'hour');
    }

    const minuteCount = Math.ceil(passedTime / 60_000);
    if (minuteCount < 0) {
      return formatter.format(minuteCount, 'minute');
    }

    return $localize`:@@menu.notifications.now:Now`;
  });
}
